import useFormatter from "@/hooks/use-formatter.hook.ts";
import { EmployeeViewModal } from "@/pages/employees/widgets/EmployeeViewModal.tsx";
import { getEmployeePositionTitle } from "@/types/employees/employee-position.types.ts";
import {
  ApiEmployee,
  ApiEmployeeLifecycleStatus,
  getEmployeeAvatarUrl,
  LifecycleStatusTexts,
} from "@/types/employees/employee.types.ts";
import { ListItem, ListItemProps, Text, useModals } from "@skailer-com/uikit";
import { ReactNode, useMemo } from "react";

export interface EmployeeListItemProps extends ListItemProps {
  employee: ApiEmployee;
  interactive?: "page" | "modal";
  valueSlot?: ReactNode;
}

export const EmployeeListItem = ({
  employee,
  interactive,
  valueSlot,
  onClick,
  ...props
}: EmployeeListItemProps) => {
  const { renderEmployeeName } = useFormatter();
  const { openModal } = useModals();
  const title = renderEmployeeName(employee);

  const handleClick: ListItemProps["onClick"] = (event) => {
    if (interactive === "modal") openModal(EmployeeViewModal, { employee });
    onClick?.(event);
  };

  const captionSlot = useMemo(() => {
    if (
      employee.lifecycle_status &&
      employee.lifecycle_status == ApiEmployeeLifecycleStatus.terminated
    ) {
      return (
        <Text className={"text-danger"}>
          {LifecycleStatusTexts()[ApiEmployeeLifecycleStatus.terminated]}
        </Text>
      );
    }
    const positionTitle = getEmployeePositionTitle(employee);
    return <Text className={"text-secondary"}>{positionTitle || "-"}</Text>;
  }, [employee]);

  return (
    <ListItem
      title={title}
      captionSlot={captionSlot}
      avatarUrl={getEmployeeAvatarUrl(employee, "sm")}
      forceShowAvatar={true}
      to={interactive === "page" ? `/employees/${employee.id}` : undefined}
      onClick={interactive === "modal" || onClick ? handleClick : undefined}
      valueSlot={valueSlot}
      blank={true}
      {...props}
    />
  );
};
